import axios from 'axios';
import Ambiente from '../util/Ambiente';

class Api {
    _usuario;

    constructor(usuario) {
        this._usuario = usuario;
    }

    get configuracao() {
        return Ambiente.urls;
    }

    async consultarParametrosBuild() {
        return Ambiente.consultarParametrosBuild();
    }

    get cpfUsuario() {
        return this._usuario && this._usuario.cpf;
    }

    get localizacao() {
        return this._usuario && this._usuario.localizacao;
    }

    /**
     * Realiza um fetch com os cabeçalhos de autenticação padrão.
     *
     * @param {string} url URL
     * @param {string} [method = GET] Método HTTP (@see {@link https://www.rfc-editor.org/rfc/pdfrfc/rfc7231.txt.pdf|RFC7231})
     * @param {string | Object | null} [data] Dados a serem enviados em uma requisição POST ou PUT
     * @param {string | Object[] | null} [addHeader] Cabeçalho(s) adicional(is)
     * @param {string} [responseType] Indica o tipo de dados esperado na resposta do servidor
     * @param {boolean} [background] Indica se a requisição deve ser executada sem exibir progresso para o usuário
     * @param {boolean} [onUploadProgress] Função para tratar progresso de upload
     * @returns {import("axios").AxiosPromise} Um objeto AxiosPromise
     */
    async fetch(url, method, data, addHeader, responseType, background, onUploadProgress) {
        let requisicao = this.getRequisicao({
            url: url,
            method: method,
            data: data,
            addHeader: addHeader,
            responseType: responseType,
            background: background,
            onUploadProgress: onUploadProgress
        });
        return axios(requisicao);
    }

    async fetchConfig(config) {
        return axios(this.getRequisicao(config));
    }

    getRequisicao(config) {
        let headers = this.authorizationHeaders || {};

        if (config.addHeader) {
            config.addHeader.forEach((header) => {
                if (header.parametro) {
                    headers[header.parametro] = header.valor;
                }
            });
        }
        config.headers = headers;
        return config;
    }

    get authorizationHeaders() {
        return this._usuario && this.headerLogus;
    }

    get headerLogus() {
        return { Authorization: 'Basic ' + this._usuario.token };
    }
}

export default Api;
